import {
  type ExtendedLocationData,
  getAccountResidentName,
  type ResidentData,
  type TinyResidentData,
} from '@terros/common'
import { formatPhone } from './formatting'

export function genderToEnglish({ gender }: ResidentData): string {
  if (gender === 'F') return 'female'
  if (gender === 'M') return 'male'
  if (gender === 'O') return 'other'
  return ''
}

export const formatResidentPhone = (props: Pick<TinyResidentData, 'phone'> | undefined): string => {
  if (!props?.phone) return ''
  const { phone } = props
  return formatPhone(phone)
}

export const stripPhone = (phone: string): string => {
  return phone.replace(/[^0-9]/g, '')
}

type LocationPossibleResident = ResidentData & {
  isTitleOwner?: boolean
}
export const getLocationPossibleResidents = ({
  titleOwners,
  residents,
}: Pick<ExtendedLocationData, 'titleOwners' | 'residents'>): LocationPossibleResident[] => {
  const deduped: LocationPossibleResident[] =
    titleOwners?.map((owner) => ({
      ...owner,
      isTitleOwner: true,
    })) ?? []
  for (const resident of residents ?? []) {
    const existingIndex = deduped.findIndex((r) => isSameResident(r, resident))
    if (existingIndex !== -1) {
      deduped[existingIndex] = {
        ...deduped[existingIndex],
        creditScore: resident.creditScore,
        age: resident.age,
      }
    } else {
      deduped.push(resident)
    }
  }
  return deduped
}

const isSameResident = (resident: TinyResidentData, other: TinyResidentData): boolean => {
  return getAccountResidentName(resident).toLowerCase() === getAccountResidentName(other).toLowerCase()
}
